import { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { Order } from '@squareup/sq-addons-web-sdk'

export const ErrorCode = {
  LOYALTY_ERROR: 'LOYALTY_ERROR',
  INVALID_USER: 'INVALID_USER',
  NO_USERS_FOUND: 'NO_USERS_FOUND',
  INVALID_OFFER: 'INVALID_OFFER',
  NO_PRIOR_REDEMPTION: 'NO_PRIOR_REDEMPTION',
}

type ApiError = {
  status: number
  data: {
    error: {
      code: string
      message: string
    }
  }
}

export function getErrorStatus(error: any): number {
  if (isApiError(error)) {
    return error.status
  }

  return 500
}

// TODO clean up the types here
export function getErrorMessage(
  error: any,
  defaultMessage = 'An Error occurred'
): string {
  return error.data.error.message || defaultMessage
}

export function getErrorCode(
  error: any,
  defaultMessage = 'LOYALTY_ERROR'
): string {
  return error?.data?.error?.code || defaultMessage
}

/**
 * Type predicate to narrow an unknown error to `FetchBaseQueryError`
 * See https://redux-toolkit.js.org/rtk-query/usage-with-typescript#inline-error-handling-example
 */
export function isFetchBaseQueryError(
  error: unknown
): error is FetchBaseQueryError {
  return typeof error === 'object' && error !== null && 'status' in error
}
export function isApiError(error: any): error is ApiError {
  if (!isFetchBaseQueryError(error)) {
    return false
  }

  const data = error.data
  if (!(data !== null && typeof data === 'object' && 'error' in data)) {
    return false
  }

  const errorData = data.error
  if (typeof errorData !== 'object' || errorData === null) {
    return false
  }

  return 'message' in errorData && typeof errorData.message === 'string'
}

// Sanitize the order object to convert any BigInt values to string
// In test at least, RTK is throwing an error when attempting to serialise BigInt
// values in the order object
export function sanitizeOrder(order: Order): Order {
  return JSON.parse(
    JSON.stringify(order, (_key, value) =>
      typeof value === 'bigint' ? value.toString() : value
    )
  )
}
